// Mock data for VoIPinger redesign. Replace with backend later.

export const SITE = {
  brand: 'VoIPinger',
  logo: '/assets/VoIPinger-Main-Logo-1.webp',
  phone: '0203 355 1151',
  phoneTel: '+442033551151',
  email: 'info@voipinger.com',
  address: '60 Copthorne Avenue, Ilford, Greater London, IG6 2SQ',
  hours: 'Mon - Fri | 9:00 - 18:00',
  loginUrl: 'https://app.voipinger.com',
  youtube: 'https://www.youtube.com/@clisecure',
  linkedin: 'https://uk.linkedin.com/company/clisecure'
};

export const NAV = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '#', mega: 'services' },
  { label: 'Features', href: '#', mega: 'features' },
  { label: 'Partners', href: '#', mega: 'partners' },
  { label: 'Company', href: '#', mega: 'company' },
  { label: 'Contact', href: '/contact' }
];

export const MEGA_MENU = {
  services: {
    title: 'Phone Systems',
    sub: 'Cloud telephony & contact centre solutions',
    columns: [
      // Logical buyer journey: the phone system → the numbers that ride on
      // it → the contact-centre layer once teams scale. Business Phone
      // System is intentionally first because it's the entry-point product
      // most visitors are looking for.
      {
        heading: 'Phone Systems',
        items: [
          { label: 'Cloud Hosted PBX', desc: 'Cloud-hosted PBX & business phone system over the internet', href: '/business-voip', icon: 'Phone' },
          { label: 'Microsoft Teams Phone', desc: 'Make Teams ring with PSTN calls', href: '/microsoft-teams', icon: 'Users' },
          { label: 'SIP Trunk', desc: 'Connect any PBX to global voice networks', href: '/sip-trunk', icon: 'Network' }
        ]
      },
      {
        heading: 'Numbers',
        items: [
          { label: 'Phone Numbers / DID', desc: 'Local numbers in 145+ countries', href: '/virtual-numbers', icon: 'Globe' },
          { label: 'CRM Integrations', desc: '250+ CRM platforms supported', href: '/crm-integrations', icon: 'Workflow' }
        ]
      },
      {
        heading: 'Contact Centre',
        items: [
          { label: 'Inbound Contact Centre', desc: 'Queues, IVR, omnichannel support', href: '/inbound-contact-centre', icon: 'PhoneIncoming' },
          { label: 'Outbound Contact Centre', desc: 'Predictive dialer for sales teams', href: '/outbound-contact-centre', icon: 'PhoneOutgoing' }
        ]
      }
    ]
  },
  features: {
    title: 'Phone Features',
    sub: 'Tools that unify how your team communicates',
    columns: [
      {
        heading: 'Communication',
        items: [
          { label: 'Web Phone & Softphone', desc: 'Cross-platform voice & messaging app', href: '/web-phone', icon: 'MonitorSmartphone' },
          { label: 'Video Conferencing', desc: 'HD video meetings with collaboration', href: '/video-conferencing', icon: 'Video' },
          { label: 'Unified Communications', desc: 'Chat, voice & video in one platform', href: '/unified-communications', icon: 'Layers' }
        ]
      },
      {
        heading: 'Productivity',
        items: [
          { label: 'Phone System Features', desc: 'Browse all 40+ telephony features', href: '/phone-features', icon: 'Sparkles' },
          { label: 'CRM Apps', desc: 'Connect to leading CRMs', href: '/crm-integrations', icon: 'Workflow' }
        ]
      }
    ]
  },
  partners: {
    title: 'Partners & Wholesale',
    sub: 'Build on the VoIPinger platform',
    columns: [
      {
        heading: 'Programs',
        items: [
          { label: 'White Label VoIP', desc: 'Reseller program with your own brand', href: '/white-label', icon: 'Tag' },
          { label: 'Wholesale VoIP', desc: 'Carrier-grade SIP minutes worldwide', href: '/wholesale-voip', icon: 'Boxes' },
          { label: 'Managed Infrastructure', desc: 'PBX-as-a-Service on our cloud', href: '/managed-infrastructure', icon: 'Server' }
        ]
      }
    ]
  },
  company: {
    title: 'Company',
    sub: 'Get to know VoIPinger',
    columns: [
      {
        heading: 'About',
        items: [
          { label: 'About Us', desc: 'Our story, mission and team', href: '/about', icon: 'Building2' },
          { label: 'Awards & Recognition', desc: 'Certifications and partner awards', href: '/awards', icon: 'Trophy' },
          { label: 'Customer Reviews', desc: 'What our customers say', href: '/reviews', icon: 'Star' },
          { label: 'Platform & Network', desc: '3 Tier-4 datacentres · 99.99% uptime', href: '/platform', icon: 'Network' }
        ]
      },
      {
        heading: 'Resources',
        items: [
          { label: 'Resources Hub', desc: 'User guides, videos and tutorials', href: '/resources', icon: 'BookOpen' },
          { label: 'Blog', desc: 'Tips, news and best practices', href: '/blog', icon: 'Newspaper' },
          { label: 'Contact', desc: 'Talk to a specialist today', href: '/contact', icon: 'Mail' }
        ]
      }
    ]
  }
};

export const HERO = {
  badge: '14 Days Free Trial · No Long Contracts',
  title: 'Run your business.',
  titleHighlight: 'From anywhere.',
  subtitle: 'Cloud-based VoIP telephony built for modern teams. Crystal-clear HD calls, smart routing, 250+ CRM integrations and a self-care portal that just works.',
  primaryCta: 'Start 14 Days Free Trial',
  secondaryCta: 'Watch Demo',
  image: '/assets/Voip-Phone-Provider.webp',
  stats: [
    { value: '250+', label: 'CRM Integrations' },
    { value: '145+', label: 'Countries Covered' },
    { value: 'HD', label: 'Crystal Audio' },
    { value: '24/7', label: 'Support' }
  ]
};

// Ordered logically for the buyer journey, mirroring the Services mega-menu:
//   1) Core phone systems     (Cloud Hosted PBX → Microsoft Teams → SIP)
//   2) Numbers + integrations  (Phone Numbers/DID → CRM Integrations)
//   3) Contact-centre layer   (Inbound → Outbound)
//   4) Add-on tooling          (Web Phone, Video, etc.)
// The first item is rendered as the featured tile in ServicesGridBento.
export const SERVICES = [
  {
    slug: 'business-voip',
    title: 'Cloud Hosted PBX',
    short: 'A modern cloud-hosted PBX and business phone system — HD audio, smart routing, and an intuitive dashboard.',
    icon: 'Phone',
    href: '/business-voip',
    features: ['HD Voice Quality', 'Custom Call Routing', 'Voicemail-2-Email', 'Video Conferencing']
  },
  {
    slug: 'microsoft-teams',
    title: 'Microsoft Teams Phone',
    short: 'Direct Routing for Teams — turn Microsoft Teams into a full-featured business phone system.',
    icon: 'Users',
    href: '/microsoft-teams',
    features: ['Direct Routing SBCs', 'Lower than Calling Plans', 'Number porting', 'Optional recording']
  },
  {
    slug: 'sip-trunk',
    title: 'SIP Trunk Packages',
    short: 'Connect worldwide at a fraction of the cost. Powerful tools tailored to your company’s needs.',
    icon: 'Network',
    href: '/sip-trunk',
    features: ['Unlimited Channels', 'UK & International', 'Quality Guaranteed', 'Pay as You Grow']
  },
  {
    slug: 'virtual-numbers',
    title: 'Phone Numbers / DID',
    short: 'Local presence in 145+ countries. Forward calls to any device anywhere in the world.',
    icon: 'Globe',
    href: '/virtual-numbers',
    features: ['145+ countries', 'Memorable numbers', 'Instant activation', 'Full IVR control']
  },
  {
    slug: 'crm',
    title: 'CRM Integrations',
    short: 'Connect your phone system with 250+ CRM platforms for seamless team collaboration.',
    icon: 'Workflow',
    href: '/crm-integrations',
    features: ['HubSpot', 'Zoho', 'Bitrix24', '+250 More']
  },
  {
    slug: 'inbound',
    title: 'Inbound Contact Centre',
    short: 'Smart queues, multi-level IVR and supervisor tools to handle every customer call professionally.',
    icon: 'PhoneIncoming',
    href: '/inbound-contact-centre',
    features: ['Skill-based routing', 'Multi-level IVR', 'Whisper & barge', 'Live wallboard']
  },
  {
    slug: 'outbound',
    title: 'Outbound Contact Centre',
    short: 'AI-driven predictive dialer, AMD and campaign manager that doubles agent talk-time.',
    icon: 'PhoneOutgoing',
    href: '/outbound-contact-centre',
    features: ['Predictive dialer', 'Campaign manager', 'AMD detection', 'Compliance tools']
  },
  {
    slug: 'web-phone',
    title: 'Web Phone / Softphone',
    short: 'Combine chat, voice and video calls in one user-friendly interface, on any device.',
    icon: 'MonitorSmartphone',
    href: '/web-phone',
    features: ['Cross Platform', 'Cheap VoIP Calls', 'Video & Messaging', 'Free Desk Space']
  },
  {
    slug: 'video',
    title: 'Video Conferencing',
    short: 'HD video meetings with screen-share, recording and AI transcription — no third-party tools.',
    icon: 'Video',
    href: '/video-conferencing',
    features: ['Up to 100 participants', 'Live transcription', 'Screen sharing', 'Calendar sync']
  }
];

export const CRM_LOGOS = [
  { name: 'Iris CRM', img: '/assets/1-1.png', href: '/crm-integrations' },
  { name: 'Zoho', img: '/assets/14-1.png', href: '/crm-integrations' },
  { name: 'Capita Housing', img: '/assets/13-1.png', href: '/crm-integrations' },
  { name: 'Bullhorn', img: '/assets/12.png', href: '/crm-integrations' },
  { name: 'Rev.io', img: '/assets/11.png', href: '/crm-integrations' },
  { name: 'Bitrix24', img: '/assets/10.png', href: '/crm-integrations' },
  { name: 'AFAS Online', img: '/assets/9.png', href: '/crm-integrations' },
  { name: 'QuickBooks', img: '/assets/8-1.png', href: '/crm-integrations' },
  { name: 'Salesforce', img: '/assets/7.png', href: '/crm-integrations' },
  { name: 'HubSpot', img: '/assets/6.png', href: '/crm-integrations' },
  { name: 'Microsoft Teams', img: '/assets/5.png', href: '/crm-integrations' },
  { name: 'Xero', img: '/assets/4-1.png', href: '/crm-integrations' },
  { name: 'Access Dimensions', img: '/assets/3-1.png', href: '/crm-integrations' }
];

export const VOIP_PRICING_MONTHLY = [
  {
    name: 'STANDARD',
    price: '£13',
    badge: '14 days free trial',
    feature: '500 minutes per user UK landline & mobile',
    items: [
      '500 inclusive minutes per user',
      'VoIP phone line',
      'Softphones for iOS & Android',
      'Webphone for PC and Mac',
      'Selfcare portal',
      'Voicemail-2-Email',
      'Call forwarding'
    ]
  },
  {
    name: 'BUSINESS',
    price: '£18',
    badge: 'Most Popular',
    highlight: true,
    feature: '2500 minutes per user UK landline & mobile',
    items: [
      'Unlimited inclusive minutes',
      'Automatic call recording',
      'Click-2-Dial',
      'Custom roles & permissions',
      'Team presence & messaging',
      'Build multiple sites',
      'SMS 4p / message'
    ]
  },
  {
    name: 'ENTERPRISE',
    price: '£35',
    badge: 'Premium',
    feature: '5000 minutes per user UK landline & mobile',
    items: [
      '5,000 minutes UK, USA & Canada',
      'Supervisor license with wallboard',
      'Agent monitoring',
      'Whisper, barge & advanced handling',
      'Daily / weekly / monthly reporting',
      'Note: Not available for predictive dialers',
      '+45 more features'
    ]
  }
];

export const VOIP_PRICING_ANNUAL = [
  { ...VOIP_PRICING_MONTHLY[0], price: '£11' },
  { ...VOIP_PRICING_MONTHLY[1], price: '£16' },
  { ...VOIP_PRICING_MONTHLY[2], price: '£25' }
];

export const SIP_PRICING = [
  {
    name: 'SHARE SIP TRUNK',
    price: '£5',
    feature: 'Per Channel',
    items: ['Unlimited Concurrent Calls', 'UK Mobile 5p', 'Landline 1p']
  },
  {
    name: 'SIP TRUNK 3000',
    price: '£15',
    highlight: true,
    feature: 'Per Channel',
    items: ['2000 UK landline minutes', '1000 UK mobile minutes', 'Call Quality Guaranteed']
  },
  {
    name: 'SIP TRUNK WORLD',
    price: '£POA',
    feature: 'One channel included',
    items: ['Choose from 3 packages', 'Europe, Americas & 30+ Countries', 'Call Quality Guaranteed']
  }
];

export const CALL_CENTRE_PACKAGES = [
  { name: 'Center Suite 5', price: '£90', setup: '£100', users: 5, ivr: 1, did: 1, trunk: 1, voicemail: 3, recording: '1 Month' },
  { name: 'Center Suite 10', price: '£160', setup: '£100', users: 10, ivr: 1, did: 5, trunk: 3, voicemail: 5, recording: '2 Months', highlight: true },
  { name: 'Center Suite 20', price: '£250', setup: '£100', users: 20, ivr: 2, did: 10, trunk: 5, voicemail: 10, recording: '3 Months' },
  { name: 'Center Suite 50', price: '£460', setup: '£200', users: 50, ivr: 2, did: 20, trunk: 10, voicemail: 20, recording: '6 Months' }
];

export const DESTINATIONS = [
  { country: 'United Kingdom', rate: '1p' },
  { country: 'USA', rate: '1p' },
  { country: 'Canada', rate: '1p' },
  { country: 'Germany', rate: '1.3p' },
  { country: 'Spain', rate: '1.3p' },
  { country: 'Denmark', rate: '1.3p' },
  { country: 'Singapore', rate: '1.3p' },
  { country: 'Poland', rate: '1.2p' },
  { country: 'Netherlands', rate: '1.9p' },
  { country: 'Australia', rate: '2.5p' },
  { country: 'India', rate: '2.5p' },
  { country: 'Luxembourg', rate: '2.5p' },
  { country: 'Switzerland', rate: '2.6p' },
  { country: 'Pakistan', rate: '7.2p' },
  { country: 'Turkey', rate: '17p' }
];

export const ADDONS = [
  { name: 'International Numbers', price: '£8', icon: 'Globe' },
  { name: 'UK Numbers', price: '£2', icon: 'Phone' },
  { name: 'CRM Integrations', price: '£9', icon: 'Workflow' },
  { name: 'Number Porting', price: '£30', icon: 'ArrowRightLeft' }
];

export const VIRTUAL_COUNTRIES = [
  { name: 'United Kingdom', code: 'GB', flag: '🇬🇧' },
  { name: 'United States', code: 'US', flag: '🇺🇸' },
  { name: 'Germany', code: 'DE', flag: '🇩🇪' },
  { name: 'France', code: 'FR', flag: '🇫🇷' },
  { name: 'Spain', code: 'ES', flag: '🇪🇸' },
  { name: 'Italy', code: 'IT', flag: '🇮🇹' },
  { name: 'Netherlands', code: 'NL', flag: '🇳🇱' },
  { name: 'Belgium', code: 'BE', flag: '🇧🇪' },
  { name: 'Sweden', code: 'SE', flag: '🇸🇪' },
  { name: 'Norway', code: 'NO', flag: '🇳🇴' },
  { name: 'Denmark', code: 'DK', flag: '🇩🇰' },
  { name: 'Finland', code: 'FI', flag: '🇫🇮' },
  { name: 'Switzerland', code: 'CH', flag: '🇨🇭' },
  { name: 'Austria', code: 'AT', flag: '🇦🇹' },
  { name: 'Ireland', code: 'IE', flag: '🇮🇪' },
  { name: 'Poland', code: 'PL', flag: '🇵🇱' },
  { name: 'Portugal', code: 'PT', flag: '🇵🇹' },
  { name: 'Greece', code: 'GR', flag: '🇬🇷' },
  { name: 'Turkey', code: 'TR', flag: '🇹🇷' },
  { name: 'Australia', code: 'AU', flag: '🇦🇺' },
  { name: 'Canada', code: 'CA', flag: '🇨🇦' },
  { name: 'India', code: 'IN', flag: '🇮🇳' },
  { name: 'Singapore', code: 'SG', flag: '🇸🇬' },
  { name: 'Hong Kong', code: 'HK', flag: '🇭🇰' },
  { name: 'Japan', code: 'JP', flag: '🇯🇵' },
  { name: 'South Africa', code: 'ZA', flag: '🇿🇦' },
  { name: 'UAE', code: 'AE', flag: '🇦🇪' },
  { name: 'New Zealand', code: 'NZ', flag: '🇳🇿' },
  { name: 'Mexico', code: 'MX', flag: '🇲🇽' },
  { name: 'Brazil', code: 'BR', flag: '🇧🇷' }
];

export const SIM_PACKAGES = [
  { name: 'SIM Starter', price: '£8', data: '5GB', minutes: '500', sms: 'Unlimited UK', popular: false },
  { name: 'SIM Business', price: '£15', data: '25GB', minutes: 'Unlimited UK', sms: 'Unlimited UK', popular: true },
  { name: 'SIM Pro', price: '£25', data: '100GB', minutes: 'Unlimited UK & EU', sms: 'Unlimited Worldwide', popular: false },
  { name: 'SIM Unlimited', price: '£35', data: 'Unlimited', minutes: 'Unlimited Worldwide', sms: 'Unlimited Worldwide', popular: false }
];

export const FAQS = [
  {
    q: 'How much does business VoIP cost?',
    a: 'Plans start from £11/user per month with our Standard package. You will need a VoIP provider, a sufficient internet connection and a SIP credential. We can either port your existing number or assign a new one at no extra cost.'
  },
  {
    q: 'What do I need to get started with VoIP?',
    a: 'A reliable internet connection (5–10 Mbps per concurrent call) and any compatible device — desktop, smartphone, tablet or IP phone. We handle the SIP credential, number provisioning and any porting required.'
  },
  {
    q: 'Do I need a special phone for VoIP?',
    a: 'No. A computer, smartphone or tablet is sufficient. If you prefer a traditional handset, any IP phone with PoE will work seamlessly with VoIPinger.'
  },
  {
    q: 'What is a Small Business VoIP system?',
    a: 'It unifies internet chat, email, SMS and calls into a single cloud platform, removing complexity from communications and providing the latest features at a small-business friendly price.'
  },
  {
    q: 'What are the advantages of VoIP systems?',
    a: 'Cost savings, HD audio, geographic flexibility, IVR, ring groups, call forwarding and queues. Plus the scalability you need to grow without rebuilding infrastructure.'
  },
  {
    q: 'Are VoIP calls good quality?',
    a: 'Yes. With modern codecs and our optimised network you get HD voice quality — indistinguishable from (and often better than) traditional telephone lines.'
  }
];

export const SIP_FAQS = [
  { q: 'SIP Channel and PRI: which is better for me?', a: 'SIP transmits over the internet whereas PRI uses traditional copper lines that require ongoing maintenance. SIP is more flexible, scalable and cost-effective.' },
  { q: 'How does SIP Trunking work?', a: 'SIP creates a VoIP session over the internet between your business phone system and our ITSP, replacing the physical infrastructure with virtual.' },
  { q: 'What is SIP Trunking used for?', a: 'It enables Direct Inward Dialing (DID), so multiple phone numbers can ring specific extensions in your company without separate physical lines.' },
  { q: 'Are there any downsides of SIP Trunking?', a: 'The main consideration is the small initial setup cost. For any business with regular call volume, SIP Trunking pays back rapidly.' },
  { q: 'How do SIP calls sound?', a: 'Identical to (often better than) traditional calls. With HD codecs there is no audible difference.' }
];

export const FEATURES = [
  { icon: 'Zap', title: 'Affordable Setup', desc: 'Save quickly on setup fees without paying for local or international call infrastructure.' },
  { icon: 'TrendingUp', title: 'Concurrent Scalability', desc: 'Add lines and users instantly without waiting for installation — grow at your own pace.' },
  { icon: 'Users', title: 'Productive Teams', desc: 'Connect teams with conference bridges and increase output regardless of location.' },
  { icon: 'CalendarCheck', title: 'No Contracts', desc: 'Choose monthly plans without long-term commitments. Pause and resume anytime.' },
  { icon: 'Headphones', title: 'Hi-Tech HD Calls', desc: 'Make crystal-clear calls with next-generation codecs and noise reduction.' },
  { icon: 'GitBranch', title: 'Smart Routing', desc: 'IVR menus, distribution rules, queues, voicemail to email — all from one dashboard.' }
];

export const TEAM_FEATURES = [
  { icon: 'MessageCircle', title: 'Group Chat', desc: 'Public and private channels keep teams aligned around topics, projects and clients.' },
  { icon: 'Send', title: 'Integrated SMS', desc: 'Send and receive SMS directly from the same interface as your calls.' },
  { icon: 'Video', title: 'Video Conferencing', desc: 'HD video meetings with screen-share, recording and dial-in for external guests.' }
];

export const NEWS = [
  {
    date: '11 May 2023',
    title: 'Why It Is Important to Set Up IVR Payment for Your Business: 5 Reasons',
    img: '/assets/why-is-it-important-to-set-up-ivr-payment-for-your-business.jpg',
    excerpt: 'IVR Payment systems improve security, reduce wait times and free up your agents to focus on revenue-generating conversations.'
  },
  {
    date: '10 May 2023',
    title: 'Why Do Your Businesses Need Phone Recording Services?',
    img: '/assets/why-do-your-businesses-need-phone-recording-services.jpg',
    excerpt: 'Compliance, training and dispute resolution — the three pillars that make phone recording essential for any modern business.'
  },
  {
    date: '09 May 2023',
    title: 'What to Look for in Call Center Software for Small Businesses',
    img: '/assets/what-are-the-criteria-to-look-for-in-a-call-center-software-solution-for-small-business-.png',
    excerpt: 'From predictive dialers to omnichannel inbox: the criteria small teams should weight when choosing call centre software.'
  }
];

export const SOFTPHONE_FEATURES = {
  // Top-of-page "all-in-one communicator" hero — AI-generated isometric
  // mockup that visually pairs with the tab carousel below. Replaces the
  // generic envelope SVG that used to live here.
  popular: '/assets/voipinger-softphone-hero.png',
  email: '/assets/Send-email-1.svg',
  messaging: '/assets/Instant-messaging-and-file-sharing-1.svg'
};

// Each tab's `media` describes what plays in the right-hand column of
// the active tab card. `type: 'video'` renders an autoplay-muted-loop
// <video>; `type: 'image'` renders a plain <img>. WebPhone.jsx falls
// back to the legacy SOFTPHONE_FEATURES SVGs when media is omitted.
export const SOFTPHONE_TABS = [
  {
    key: 'softphone', label: 'Soft Phone', icon: 'Phone',
    title: 'Softphone with all the popular features',
    desc: 'The communicator is a free Softphone developed by VoIPinger. The easy-to-use interface allows users to make and receive calls as if it were a physical desktop phone, with messaging, presence, phone directory and fax2email.',
    points: ['Drag & drop dialling', 'Call control & transfer', 'Caller ID & pop-ups', 'Multiple phone lines'],
    media: { type: 'video', url: '/assets/videos/voipinger-drag-drop-dialing.mp4' }
  },
  {
    key: 'voice', label: 'Voice & Video', icon: 'Video',
    title: 'Crystal voice & video calls',
    desc: 'Talk to your co-workers, associates, friends and family straight from your desktop or laptop computer with HD audio and video.',
    points: ['One-click voice calls', 'Face-to-face video calls', 'Call recording', 'Speed dial & redial'],
    media: { type: 'video', url: '/assets/videos/voipinger-voice-video.mp4' }
  },
  {
    key: 'conference', label: 'Conferencing', icon: 'Users',
    title: 'Conference rooms in seconds',
    desc: 'Organise meetings with associates and co-workers from the comfort of your office. Drag & drop a third person into your call to start a conference.',
    points: ['Audio conferencing', 'Dynamic conferencing', '3-way SIP calls', 'Kick / mute participants'],
    media: { type: 'image', url: '/assets/voipinger-conferencing.png' }
  },
  {
    key: 'voicemail', label: 'Visual Voicemail', icon: 'Voicemail',
    title: 'Read your voicemails, don\'t listen to them',
    desc: 'Every voicemail comes with an automatic text transcript so you can scan, search and prioritise messages in seconds — even on silent mode.',
    points: ['Auto transcripts', 'Email forwarding', 'Play from any device', 'Search transcripts'],
    media: { type: 'image', url: '/assets/voipinger-voicemail.png' }
  },
  {
    key: 'messaging', label: 'Messaging', icon: 'MessageSquare',
    title: 'Instant messaging & file sharing',
    desc: 'Send instant messages, exchange files, use screen sharing and reach entire departments via company channels.',
    points: ['Group chat & rooms', 'File sharing', 'Chat history search', 'SSL encryption'],
    media: { type: 'video', url: '/assets/videos/voipinger-chat.mp4' }
  },
  {
    key: 'address', label: 'Address Book', icon: 'BookUser',
    title: 'Unified contacts',
    desc: 'Communicator has a native phonebook plus integration with Apple Address Book, Outlook and Google Contacts.',
    points: ['Outlook contacts', 'Google contacts', 'Apple Address Book', 'Search & favourites'],
    // `compact: true` tells WebPhone.jsx to render this image at a smaller
    // capped width — the AI mockup is essentially a 1:1 icon, so filling
    // the column would make it look oversized next to the landscape clips.
    media: { type: 'image', url: '/assets/voipinger-address-book.png', compact: true }
  },
  {
    key: 'productivity', label: 'Productivity', icon: 'Rocket',
    title: 'Built for productive teams',
    desc: 'Drag & drop actions, file sharing, faxing and in-text dialing turn your communicator into a productivity hub.',
    points: ['Drag & drop actions', 'File sharing', 'Faxing', 'Speed dial'],
    media: { type: 'image', url: '/assets/voipinger-productivity.png', compact: true }
  }
];

export const STEPS_NEW_NUMBER = [
  { n: '1', title: 'Choose a Number', desc: 'Pick a memorable UK or international number from our inventory.' },
  { n: '2', title: 'Select a Tariff', desc: 'Pair it with the plan that fits your team size and call volume.' },
  { n: '3', title: 'You’re All Set', desc: 'We provision everything in the cloud — no waiting, no hardware.' },
  { n: '4', title: '1 Minute Flat', desc: 'You’ll be live and taking calls in less than a minute.' }
];

export const STEPS_TRANSFER = [
  { n: '1', title: 'We Do Everything', desc: 'Provide your details — we’ll handle the porting paperwork end to end.' },
  { n: '2', title: '5–10 Days', desc: 'Standard porting completes in 5 to 10 working days, with zero downtime.' },
  { n: '3', title: 'You’re All Set', desc: 'Your existing number works as before, now powered by VoIPinger.' }
];

export const TRUST_BADGES = [
  { icon: 'Rocket', title: 'Next-day setup' },
  { icon: 'Gift', title: '14 days free trial' },
  { icon: 'LifeBuoy', title: 'Professional support team' }
];

// ============= NEW PAGES DATA =============

// Hero images for the bespoke service pages.
//
// These are AI-generated illustrations stored in frontend/public/assets/heroes/
// — see the "AI hero images" commit in the git history. Brand-consistent
// violet/fuchsia palette, isometric / flat illustration style, no text /
// no logos so they age well and don't lock the page to a specific copy.
export const NEW_PAGE_IMAGES = {
  about:        '/assets/heroes/platform.png',
  videoConf:    '/assets/heroes/video-conferencing.png',
  uc:           '/assets/heroes/unified-communications.png',
  infra:        '/assets/heroes/platform.png',
  teams:        '/assets/heroes/microsoft-teams.png',
  businessVoip: '/assets/heroes/business-voip.png',
  inbound:      '/assets/heroes/inbound-contact-centre.png',
  outbound:     '/assets/heroes/outbound-contact-centre.png',
  webPhone:     '/assets/heroes/web-phone.png',
  crm:          '/assets/heroes/crm-integrations.png',
  features:     '/assets/heroes/phone-features.png',
  numbers:      '/assets/heroes/virtual-numbers.png',
  platform:     '/assets/heroes/platform.png',
  comparison:   '/assets/heroes/calling-plans-vs-teammate.png',
};

export const PLATFORM_PILLARS = [
  { icon: 'Cloud', title: 'Cloud-Native Architecture', desc: 'Fully cloud-based for maximum reliability, scalability and rapid deployment.' },
  { icon: 'Plug', title: 'API Integration Hub', desc: 'A central hub to seamlessly connect your business applications and systems.' },
  { icon: 'Activity', title: 'Real-Time Analytics', desc: 'Instant call and message insights for agile communication management.' },
  { icon: 'Globe2', title: 'Global Voice Network', desc: 'A dedicated voice transmission network covering 145+ countries worldwide.' }
];

export const GLOBAL_STATS = [
  { value: '145+', label: 'Countries Covered' },
  { value: '99.9%', label: 'Network Uptime' },
  { value: '93%', label: 'World Economy Coverage' },
  { value: '24/7', label: 'Global Support' }
];

export const TRUST_PARTNERS = [
  { name: 'ISO 27001', icon: 'ShieldCheck' },
  { name: 'GDPR Compliant', icon: 'Lock' },
  { name: 'Ofcom Registered', icon: 'BadgeCheck' },
  { name: '30-Day Money Back', icon: 'RefreshCw' },
  { name: 'Next-Day Setup', icon: 'Rocket' },
  { name: 'UK Based Support', icon: 'Headset' }
];

// Microsoft Teams page
export const TEAMS_FEATURES = [
  { icon: 'PhoneCall', t: 'Direct Routing', d: 'Connect Teams to the PSTN with carrier-grade SBC infrastructure managed by us.' },
  { icon: 'Wallet', t: 'Cost savings', d: 'Lower per-minute pricing than Microsoft Calling Plans, especially internationally.' },
  { icon: 'Globe', t: 'Global numbers', d: 'Provision UK & international numbers and assign them directly inside Teams.' },
  { icon: 'BarChart3', t: 'Call analytics', d: 'Detailed reporting beyond what Microsoft offers natively, in real time.' },
  { icon: 'Headphones', t: 'Survivability', d: 'Failover voice trunks keep your team online if Teams has an outage.' },
  { icon: 'ShieldCheck', t: 'Compliance', d: 'Optional call recording with legal-grade encryption and retention controls.' }
];

// Inbound Contact Centre page
export const INBOUND_FEATURES = [
  { icon: 'PhoneIncoming', t: 'Smart Queues', d: 'Skill-based routing keeps customers on the line and connected to the right agent.' },
  { icon: 'GitFork', t: 'Multi-level IVR', d: 'Visual IVR builder with audio, text-to-speech, branching and transfers.' },
  { icon: 'Mic', t: 'Whisper & Barge', d: 'Supervisors can coach in real time without the customer hearing.' },
  { icon: 'BarChart3', t: 'Live Wallboard', d: 'Real-time dashboards for service levels, queues, agents and customer experience.' },
  { icon: 'Inbox', t: 'Omnichannel', d: 'Calls, email, SMS and webchat in one unified agent console.' },
  { icon: 'Repeat', t: 'Callback Manager', d: 'Offer customers a callback to skip the queue and improve satisfaction.' }
];

// Outbound Contact Centre page
export const OUTBOUND_FEATURES = [
  { icon: 'Zap', t: 'Predictive Dialer', d: 'AI-driven pacing keeps your agents talking instead of waiting on dial tones.' },
  { icon: 'List', t: 'Campaign Manager', d: 'Set quotas, exclusions and dialing rules per list, all from a web console.' },
  { icon: 'BotMessageSquare', t: 'Answering Machine Detection', d: 'Filter voicemails accurately to maximise live conversation time.' },
  { icon: 'Calendar', t: 'Scheduled Callbacks', d: 'Agent-only and team-wide callback scheduling with automatic dial.' },
  { icon: 'FileText', t: 'Disposition Tracking', d: 'Customisable wrap-up codes feed straight into your CRM and analytics.' },
  { icon: 'Shield', t: 'Compliance Tools', d: 'TPS / TCPA / DNC list checks, time-window rules and recording consent.' }
];

// Video Conferencing
export const VIDEO_FEATURES = [
  { icon: 'Video', t: 'HD Video & Audio', d: 'Up to 1080p video and Opus HD audio with built-in echo cancellation.' },
  { icon: 'ScreenShare', t: 'Screen sharing', d: 'Share an app, a tab or your full desktop with a single click.' },
  { icon: 'Users', t: 'Up to 100 participants', d: 'Run team standups, all-hands and webinars without third-party tools.' },
  { icon: 'Captions', t: 'Live transcription', d: 'AI-powered captions and recording transcripts in 30+ languages.' },
  { icon: 'Hand', t: 'Reactions & raise-hand', d: 'Keep meetings interactive with native reactions, polls and Q&A.' },
  { icon: 'Calendar', t: 'Calendar sync', d: 'One-click join from Outlook and Google Calendar invites.' }
];

// Unified Communications
export const UC_PILLARS = [
  { icon: 'PhoneCall', t: 'Voice', d: 'Inbound, outbound, internal and external calls on any device.' },
  { icon: 'Video', t: 'Video', d: 'HD meetings, screen-share, recording and transcription.' },
  { icon: 'MessageSquare', t: 'Messaging', d: 'Direct messages, group rooms, file-sharing and topic channels.' },
  { icon: 'Users', t: 'Presence', d: 'See who is available, on a call or in a meeting in real time.' },
  { icon: 'Workflow', t: 'CRM Workflow', d: 'Auto-log calls, screen-pop and trigger automations in your CRM.' },
  { icon: 'Smartphone', t: 'Mobility', d: 'Same number, same identity, on desk phone, mobile and browser.' }
];

// Headline / spotlight features — the differentiated capabilities that
// matter most in a sales conversation. These come straight from the
// platform feature brochure and are rendered with rich descriptions
// at the top of the Phone Features page.
export const HEADLINE_FEATURES = [
  {
    icon: 'Sparkles', accent: 'violet', tag: 'AI',
    name: 'AI / IVR Speech Recognition',
    blurb: 'Callers say "sales" or "technical support" instead of pressing a digit — the IVR understands and transfers them straight to the right team or extension.'
  },
  {
    icon: 'AudioLines', accent: 'fuchsia', tag: 'AI',
    name: 'Conversational Transcription',
    blurb: 'Every recorded call is automatically transcribed and split per speaker, so you can search hundreds of conversations like a Google doc.'
  },
  {
    icon: 'HeartPulse', accent: 'rose', tag: 'AI',
    name: 'Sentiment Analysis',
    blurb: 'Each transcript segment is colour-coded green / amber / red. Spot quality and compliance issues at a glance — no more random spot-checks.'
  },
  {
    icon: 'Search', accent: 'sky', tag: 'Quality',
    name: 'Call Trace & MOS',
    blurb: 'Full SIP ladder, PCAP and MOS quality score for every call. Diagnose jitter and packet loss after the fact instead of trying to reproduce the fault.'
  },
  {
    icon: 'Code2', accent: 'indigo', tag: 'Platform',
    name: 'Open RESTful API',
    blurb: '240+ APIs and 300+ pre-built orchestrations across provisioning, recordings, conferencing, dial-plans and contact-centre. Build any integration you can imagine.'
  },
  {
    icon: 'LayoutDashboard', accent: 'amber', tag: 'Analytics',
    name: 'Live Wallboards',
    blurb: 'Drag-and-drop dashboards with Gauge, Table, Grid, Stat Block and IFrame cards. Configurable thresholds with visual + audible alerts.'
  },
  {
    icon: 'PhoneCall', accent: 'emerald', tag: 'Contact Centre',
    name: 'Five queue types',
    blurb: 'Round-Robin, Linear Hunt, Linear Cascade, Ring-All and Call Park — pick the routing model that matches each team. Supervisor whisper, barge and monitoring built in.'
  },
  {
    icon: 'Video', accent: 'teal', tag: 'Collaboration',
    name: 'Meetings & Webinars',
    blurb: 'Native WebRTC video collaboration — up to 50 in a conference, up to 1,000 in a webinar. No software install, calendar integration and recording included.'
  },
  {
    icon: 'Settings2', accent: 'slate', tag: 'Admin',
    name: 'Endpoint Device Management',
    blurb: '250+ supported devices from 21+ manufacturers (SIP handsets, ATAs, door entry, softphones). Visual button-mapping tool with templates — no telephony engineer required.'
  }
];

// Phone System Features (40+ filterable grid)
// `blurb` is shown on hover / detail — short plain-English description.
export const ALL_FEATURES = [
  // ---- Calling ----
  { cat: 'Calling', icon: 'PhoneCall', name: 'HD Voice', blurb: 'Wideband G.722 + Opus codecs for crisp, low-distortion conversations.' },
  { cat: 'Calling', icon: 'PhoneForwarded', name: 'Call Forwarding', blurb: 'Forward to any number, extension or voicemail — conditional or unconditional.' },
  { cat: 'Calling', icon: 'PhoneOff', name: 'Do Not Disturb', blurb: 'Block all incoming calls with one tap; resume with the same.' },
  { cat: 'Calling', icon: 'PhoneIncoming', name: 'Caller ID', blurb: 'See who is calling on every device — name lookups from CRMs supported.' },
  { cat: 'Calling', icon: 'PhoneOutgoing', name: 'Click-to-Dial', blurb: 'Dial any number on a web page, CRM, or email signature with a single click.' },
  { cat: 'Calling', icon: 'Repeat', name: 'Call Pickup & Park', blurb: 'Pick up a colleague\'s ringing phone, or park a call to retrieve from any device.' },
  { cat: 'Calling', icon: 'Hash', name: 'Speed Dial', blurb: 'One-press dialling for your most-called numbers, configurable per user.' },
  { cat: 'Calling', icon: 'PhoneCall', name: 'Three-Way Calling', blurb: 'Bring a third party into any active call — caller, callee and you.' },
  { cat: 'Calling', icon: 'PhoneOutgoing', name: 'Click-to-Dial from CRM', blurb: 'Dial directly from Salesforce, HubSpot, Zoho and 200+ other apps.' },

  // ---- Routing ----
  { cat: 'Routing', icon: 'GitFork', name: 'IVR Menus', blurb: 'Drag-drop IVR builder with conditional logic, time-of-day branching and prompts in any language.' },
  { cat: 'Routing', icon: 'Mic', name: 'Speech-Recognition IVR', blurb: 'Spoken keywords route callers to the right team — no digit pressing.' },
  { cat: 'Routing', icon: 'Layers', name: 'Ring Groups', blurb: 'Ring a team of phones simultaneously or in sequence until someone picks up.' },
  { cat: 'Routing', icon: 'Clock', name: 'Time-Based Routing', blurb: 'Different routes for business hours, out-of-hours, lunch breaks and bank holidays.' },
  { cat: 'Routing', icon: 'Globe', name: 'Geo-routing', blurb: 'Route callers to the regional office nearest their dialling country.' },
  { cat: 'Routing', icon: 'ListOrdered', name: 'Call Queues', blurb: 'Round-Robin, Linear Hunt, Linear Cascade, Ring-All and Call Park — five routing models.' },
  { cat: 'Routing', icon: 'BellRing', name: 'Priority Calls', blurb: 'VIP customers jump to the front of the queue with a configurable rule.' },
  { cat: 'Routing', icon: 'PhoneCall', name: 'Call Back from Queue', blurb: 'Callers can keep their place in the queue and get called back when an agent is free.' },
  { cat: 'Routing', icon: 'CalendarDays', name: 'Holiday Calendars', blurb: 'Pre-load bank holidays so out-of-hours routing engages automatically.' },

  // ---- Productivity ----
  { cat: 'Productivity', icon: 'Voicemail', name: 'Voicemail-to-Email', blurb: 'Each voicemail lands in your inbox as an MP3 — Google transcription optional.' },
  { cat: 'Productivity', icon: 'Mic2', name: 'Voicemail Transcription', blurb: 'Read your voicemails as text in the app, the portal and your email.' },
  { cat: 'Productivity', icon: 'FileAudio', name: 'Call Recording', blurb: 'On-demand or always-on; QoS scored, with retention rules and audit log.' },
  { cat: 'Productivity', icon: 'BookUser', name: 'Shared Phonebook', blurb: 'Company directory synced to every device, with extension dial.' },
  { cat: 'Productivity', icon: 'Bookmark', name: 'Favourites', blurb: 'Star contacts you call often — see them at the top of every device.' },
  { cat: 'Productivity', icon: 'Music', name: 'Music on Hold', blurb: 'Upload your own MP3s or use platform defaults; different per queue, site or domain.' },
  { cat: 'Productivity', icon: 'Speaker', name: 'Text-to-Speech', blurb: 'Type your greetings and prompts — the platform converts to audio in 30+ voices.' },
  { cat: 'Productivity', icon: 'StickyNote', name: 'Call Notes', blurb: 'Take notes during a call and save them to the contact record.' },

  // ---- Collaboration ----
  { cat: 'Collaboration', icon: 'Video', name: 'Video Meetings', blurb: 'Up to 50 participants per conference room — full UC mode, WebRTC, no install.' },
  { cat: 'Collaboration', icon: 'Megaphone', name: 'Webinars', blurb: 'Up to 1,000 participants with host / attendee / guest roles, recording and chat.' },
  { cat: 'Collaboration', icon: 'MessageSquare', name: 'Team Chat', blurb: 'One-to-one and group messaging in the web app, mobile and desktop.' },
  { cat: 'Collaboration', icon: 'ScreenShare', name: 'Screen Share', blurb: 'Share a single window or full desktop with active-speaker detection.' },
  { cat: 'Collaboration', icon: 'Send', name: 'Internal SMS', blurb: 'Send a quick SMS to any colleague directly from their contact card.' },
  { cat: 'Collaboration', icon: 'Users', name: 'Conference Rooms', blurb: 'Persistent meeting rooms with their own URL — share and reuse.' },
  { cat: 'Collaboration', icon: 'Calendar', name: 'Calendar Integration', blurb: 'Meetings sync with Outlook and Google calendars in both directions.' },

  // ---- Analytics ----
  { cat: 'Analytics', icon: 'BarChart3', name: 'Live Wallboard', blurb: 'Drag-drop boards (Gauge / Table / Grid / Stat Block / IFrame) with visual + audible alerts.' },
  { cat: 'Analytics', icon: 'LineChart', name: 'Detailed Reporting', blurb: 'Pre-built and custom reports across queues, agents and sites — schedulable.' },
  { cat: 'Analytics', icon: 'Activity', name: 'Quality Metrics', blurb: 'MOS score, jitter and packet-loss for every call — predict issues before customers report them.' },
  { cat: 'Analytics', icon: 'Gauge', name: 'Service Levels', blurb: 'SLA-tracking with thresholds for CW, AWT, AHT, ABN, CA and CV.' },
  { cat: 'Analytics', icon: 'PieChart', name: 'Disposition Codes', blurb: 'Tag every call with a reason — feeds your campaign and queue analytics.' },
  { cat: 'Analytics', icon: 'HeartPulse', name: 'Sentiment Analysis', blurb: 'AI-tagged transcript segments — green / amber / red flags for QA review.' },
  { cat: 'Analytics', icon: 'Search', name: 'Call Trace', blurb: 'Full SIP ladder, PCAP and MOS score after the fact — fix faults without re-creating them.' },

  // ---- Admin ----
  { cat: 'Admin', icon: 'Settings', name: 'Self-Care Portal', blurb: 'End users manage answering rules, voicemail, time frames and devices without raising tickets.' },
  { cat: 'Admin', icon: 'UserCog', name: 'Roles & Permissions', blurb: 'Simple / Basic / Advanced or fully custom user profiles — per-feature access.' },
  { cat: 'Admin', icon: 'Building2', name: 'Multi-Site Setup', blurb: 'Sites and departments organise users, queues and routing — filter analytics by either.' },
  { cat: 'Admin', icon: 'KeyRound', name: 'SSO Login', blurb: 'Single sign-on with Google Workspace and Microsoft 365 / Entra ID.' },
  { cat: 'Admin', icon: 'ShieldCheck', name: 'Compliance', blurb: 'GDPR, PCI-DSS pause/resume on recordings, retention rules and audit logs.' },
  { cat: 'Admin', icon: 'Settings2', name: 'Endpoint Device Management', blurb: '250+ supported devices, 21+ manufacturers. Visual button-mapping with templates and locking.' },
  { cat: 'Admin', icon: 'Network', name: 'n-Share Geo Redundancy', blurb: 'Three Tier-4 datacentres (London, Amsterdam, Las Vegas) acting as one — 99.99% uptime.' },
  { cat: 'Admin', icon: 'Code2', name: 'Open API', blurb: '240+ REST APIs, 300+ orchestrations — provisioning, reporting, real-time control.' },

  // ---- Mobility ----
  { cat: 'Mobility', icon: 'Smartphone', name: 'Mobile App (iOS / Android)', blurb: 'Brandable softphone with visual voicemail, presence and seamless WiFi / cellular handoff.' },
  { cat: 'Mobility', icon: 'Monitor', name: 'Desktop App', blurb: 'Native softphone with click-to-dial, presence and call pop on Windows + macOS.' },
  { cat: 'Mobility', icon: 'AppWindow', name: 'Web Phone', blurb: 'WebRTC softphone in any browser — no install, login with Google / Microsoft 365.' },
  { cat: 'Mobility', icon: 'PhoneCall', name: 'Number Portability', blurb: 'Port your existing UK or international numbers — single or range, no downtime.' },
  { cat: 'Mobility', icon: 'ArrowLeftRight', name: 'Call Handover', blurb: 'Switch a live call between desk, mobile and web phone without dropping the line.' },
  { cat: 'Mobility', icon: 'Users', name: 'MS Teams Integration', blurb: 'Direct Routing SBC included — use Teams as your softphone with our PSTN.' },
  { cat: 'Mobility', icon: 'Workflow', name: 'CRM Integration', blurb: 'Go Integrator NAVA + 200+ apps — click-to-dial, contact pop, activity logging.' }
];

// White Label / Reseller
export const WHITELABEL_BENEFITS = [
  { icon: 'Tag', t: 'Your brand, our platform', d: 'Sell VoIP, video and messaging under your own brand with a custom dashboard, login portal and apps.' },
  { icon: 'PoundSterling', t: 'Wholesale pricing', d: 'Generous margins on numbers, minutes and seats — keep recurring revenue, we handle the network.' },
  { icon: 'LifeBuoy', t: 'White-label support', d: 'Optional 24/7 NOC and tier-2/3 escalation under your brand for faster customer resolution.' },
  { icon: 'Cloud', t: 'No infrastructure', d: 'No need for switches, SBCs or carriers — we run a multi-tenant cloud you control.' },
  { icon: 'Workflow', t: 'API & automations', d: 'Provision customers, numbers and CDRs via REST APIs and webhooks.' },
  { icon: 'GraduationCap', t: 'Onboarding & training', d: 'Sales playbooks, marketing collateral and engineer training included.' }
];

// Wholesale VoIP
export const WHOLESALE_PLANS = [
  { name: 'STARTER', price: 'Custom', feature: 'Pay-as-you-go SIP minutes', items: ['Tier-1 termination', 'No commitment', 'Real-time CDR', 'Basic LCR'], highlight: false },
  { name: 'GROWTH', price: 'Custom', feature: 'Discounted committed volume', items: ['Tier-1 + Tier-2 routes', 'Custom LCR', 'White-glove onboarding', 'Account manager'], highlight: true },
  { name: 'CARRIER', price: 'Custom', feature: 'Carrier interconnect', items: ['BGP / private peering', 'SLA & redundancy', 'Multi-region SBCs', 'Dedicated trunks'], highlight: false }
];

// Managed Infrastructure
export const INFRA_FEATURES = [
  { icon: 'Server', t: 'PBX as a Service', d: 'Multi-tenant cloud PBX hosted in tier-3 UK & EU data centres with active failover.' },
  { icon: 'Cloud', t: 'Geo-redundant', d: 'Calls keep flowing even if a data centre fails — automatic re-registration in seconds.' },
  { icon: 'Wifi', t: 'Carrier-grade SBCs', d: 'Session border controllers with NAT traversal, anti-fraud and codec transcoding.' },
  { icon: 'ShieldCheck', t: '24/7 NOC', d: 'Network operations centre monitors performance, latency and abuse round the clock.' },
  { icon: 'BarChart3', t: 'Detailed metrics', d: 'Per-tenant dashboards for MOS, jitter, ASR, ACD and more.' },
  { icon: 'KeyRound', t: 'Compliance ready', d: 'GDPR, ISO 27001 and PCI-DSS-aware infrastructure for regulated workloads.' }
];

// About Us
export const ABOUT_VALUES = [
  { icon: 'Heart', t: 'Customer obsessed', d: 'We measure success by the calls our customers complete, not by the dashboards we ship.' },
  { icon: 'ShieldCheck', t: 'Reliable by design', d: 'Multi-region redundancy, real-time monitoring and a 99.9% uptime SLA — by default.' },
  { icon: 'Sparkles', t: 'Effortlessly modern', d: 'No clunky enterprise UI. Every feature is designed to be picked up in minutes.' },
  { icon: 'PoundSterling', t: 'Honest pricing', d: 'No long contracts, no hidden fees. We win by being good — not by trapping you.' }
];

export const TIMELINE = [
  { year: '2014', t: 'Founded in London', d: 'VoIPinger was born out of CLI Secure with a mission to bring enterprise-grade telephony to small UK businesses.' },
  { year: '2017', t: 'Vicidial launch', d: 'Added a fully-managed Vicidial contact-centre offering, becoming a reference partner for UK call centres.' },
  { year: '2020', t: 'CRM integrations hub', d: 'Reached 100+ CRM integrations and launched our open public API for partners.' },
  { year: '2023', t: 'Global voice network', d: 'Expanded to 145+ countries with carrier interconnects and our own SBC fabric.' },
  { year: '2026', t: 'AI-powered telephony', d: 'Launched AI transcription, smart routing and quality scoring across all plans.' }
];

export const TEAM = [
  { name: 'Alex Mercer', role: 'Founder & CEO', initials: 'AM', tone: 'from-violet-500 to-fuchsia-500' },
  { name: 'Priya Patel', role: 'CTO', initials: 'PP', tone: 'from-violet-600 to-purple-500' },
  { name: 'Daniel Kowalski', role: 'VP Customer Success', initials: 'DK', tone: 'from-purple-500 to-fuchsia-500' },
  { name: 'Sara Lindqvist', role: 'Head of Product', initials: 'SL', tone: 'from-fuchsia-500 to-violet-500' },
  { name: 'Mohammed Al-Farsi', role: 'Network Architect', initials: 'MA', tone: 'from-violet-500 to-purple-600' },
  { name: 'Chloe Moreau', role: 'Head of Marketing', initials: 'CM', tone: 'from-purple-600 to-fuchsia-600' }
];

// Awards
export const AWARDS_LIST = [
  { year: '2026', name: 'Best Cloud Communications Provider UK', org: 'Comms Business Awards', icon: 'Trophy' },
  { year: '2025', name: 'Top 50 SaaS Companies', org: 'TechRound 100', icon: 'Award' },
  { year: '2025', name: 'Excellence in Customer Service', org: 'UK Customer Experience Awards', icon: 'Star' },
  { year: '2024', name: 'Most Innovative VoIP Platform', org: 'CRN Tech Innovator Awards', icon: 'Sparkles' },
  { year: '2024', name: 'Best Reseller Programme', org: 'Channel Partner Insight', icon: 'Tag' },
  { year: '2023', name: 'Highest Rated VoIP on Reviews.co.uk', org: 'Reviews.co.uk', icon: 'Heart' }
];

export const CERTIFICATIONS = [
  { name: 'ISO 27001:2022', desc: 'Information security management', icon: 'ShieldCheck' },
  { name: 'ISO 9001:2015', desc: 'Quality management system', icon: 'BadgeCheck' },
  { name: 'GDPR Compliant', desc: 'EU & UK data protection', icon: 'Lock' },
  { name: 'Ofcom Registered', desc: 'UK telecoms authority', icon: 'Building2' },
  { name: 'Cyber Essentials Plus', desc: 'NCSC cyber-security baseline', icon: 'Shield' },
  { name: 'PCI DSS Aware', desc: 'Card data handling compliance', icon: 'CreditCard' }
];

// Reviews
export const REVIEWS = [
  { name: 'Emma Carter', company: 'Linden Estates', role: 'Operations Manager', rating: 5, msg: 'We migrated 32 lines in a weekend. Calls are crystal clear and the dashboard is the cleanest we have used.' },
  { name: 'Daniel Reyes', company: 'Reyes Logistics', role: 'Founder', rating: 5, msg: 'The HubSpot integration saved our agents hours every week. No more copy-pasting numbers.' },
  { name: 'Priya Sharma', company: 'Northstar Tech', role: 'Head of Support', rating: 5, msg: 'Vicidial inside VoIPinger transformed our outbound campaigns. Reporting and AMD work flawlessly.' },
  { name: 'James O’Connor', company: 'Bright Health Group', role: 'IT Director', rating: 5, msg: 'The Microsoft Teams Direct Routing setup was painless. Their team handled the whole migration in 48 hours.' },
  { name: 'Aisha Khan', company: 'Velocity Recruiters', role: 'Sales Director', rating: 5, msg: 'Predictive dialer doubled our agent productivity in week one. AMD and disposition codes are spot on.' },
  { name: 'Tomasz Nowak', company: 'Nowak Plumbing Co.', role: 'Owner', rating: 5, msg: 'Small business and the support is fantastic. Real humans, real fast, no scripts.' },
  { name: 'Sofia Martins', company: 'Lumiere Boutiques', role: 'Customer Care Lead', rating: 5, msg: 'IVR builder is so visual our team configured the flow themselves. No more support tickets to change a menu.' },
  { name: 'Lucas Petrov', company: 'Petrov Transport', role: 'Co-founder', rating: 4, msg: 'We saved 38% on our phone bill in the first quarter. Solid platform, solid pricing.' },
  { name: 'Hannah Bell', company: 'Bell & Associates Law', role: 'Managing Partner', rating: 5, msg: 'Compliance-grade call recording with retention rules — exactly what our regulators demand.' }
];

export const REVIEW_STATS = [
  { value: '4.9', label: 'Average rating', sub: 'across 1,200+ reviews' },
  { value: '98%', label: 'Recommend us', sub: 'would refer a friend' },
  { value: '< 2 min', label: 'Avg. response time', sub: 'to a support ticket' },
  { value: '99.9%', label: 'Uptime SLA', sub: 'measured monthly' }
];

// Happy Clients (logos for Home enrichment)
export const CLIENT_LOGOS = [
  { name: 'Linden Estates', text: 'LINDEN' },
  { name: 'Reyes Logistics', text: 'REYES' },
  { name: 'Northstar Tech', text: 'NORTHSTAR' },
  { name: 'Bright Health', text: 'BRIGHT+' },
  { name: 'Velocity', text: 'VELOCITY' },
  { name: 'Lumiere', text: 'LUMIERE' },
  { name: 'Bell & Co.', text: 'BELL & CO.' },
  { name: 'Nowak', text: 'NOWAK' }
];

